"use strict";
window.SHIGETA_THEME_CUSTOMIZE = window.SHIGETA_THEME_CUSTOMIZE || {};

(function($$) {
  // 送料無料バーアプリ 有効化チェック
  (function() {
    window.addEventListener('load', (e) => {
      let barAppUrl = 'https://free-shipping-bar-pr-js.firebaseapp.com/bar.js',
          scriptElementAll = document.querySelectorAll('script');
      [...scriptElementAll].forEach((scriptElement) => {
        if(scriptElement.src.indexOf(barAppUrl) !== -1) {
          document.body.classList.add('is-free-shipping-bar-enabled');
          if(theme && theme.config && theme.config.stickyHeader) {
            document.body.classList.add('is-sticky-header-enabled');
          }
        }
      });
    })
  })();

  // SHIGETA header: transparent on the key visual, solid when returning upward.
  (function() {
    const initHeader = () => {
      const wrapper = document.querySelector('[data-c-header-wrapper]');
      const siteHeader = document.getElementById('SiteHeader');

      if (!wrapper || !siteHeader || wrapper.dataset.cHeaderInitialized === 'true') {
        return;
      }

      wrapper.dataset.cHeaderInitialized = 'true';

      const isHomeHeader = wrapper.dataset.cHeaderHome === 'true';
      const headerSection = wrapper.closest('.header-section');
      const hero = document.querySelector('.c-hero-video');
      const dropdownOpenClass = 'c-header-wrapper--dropdown-open';
      const hiddenClass = 'c-header-wrapper--hidden';
      const fixedClass = 'c-header-wrapper--fixed';
      const fixedSectionClass = 'c-header-section--fixed';
      const noTransitionClass = 'c-header-wrapper--no-transition';
      const dropdownItemSelector = '.c-header__nav-item.site-nav--has-dropdown';
      const desktopNav = wrapper.querySelector('.c-header__nav');
      const clickOpenAttribute = 'data-c-header-click-open';
      const clickOpenClass = 'c-header__nav-item--click-open';
      let lastScrollY = window.scrollY;
      let isHeaderRevealed = false;
      let isHeaderHidden = false;
      let isPointerInsideHeader = false;
      let hasUpdatedHeader = false;
      let ticking = false;

      const getHeroBottom = () => {
        if (!hero) {
          return 0;
        }

        return hero.getBoundingClientRect().bottom + window.scrollY;
      };

      const setHeaderHidden = (hidden, immediate) => {
        isHeaderHidden = hidden;

        if (immediate) {
          wrapper.classList.add(noTransitionClass);
        }

        wrapper.classList.toggle(hiddenClass, hidden);

        if (immediate) {
          window.requestAnimationFrame(() => {
            wrapper.classList.remove(noTransitionClass);
          });
        }
      };

      const setHeaderFixed = (fixed, headerHeight) => {
        wrapper.classList.toggle(fixedClass, fixed);

        if (!headerSection) {
          return;
        }

        headerSection.classList.toggle(fixedSectionClass, fixed && !isHomeHeader);
        headerSection.style.setProperty('--c-header-placeholder-height', fixed && !isHomeHeader ? `${headerHeight}px` : '0px');
      };

      const setCollectionFilterStickyTop = (headerVisible, headerHeight) => {
        const stickyTop = headerVisible ? `${headerHeight}px` : '0px';

        document.documentElement.style.setProperty('--collection-filter-sticky-top', stickyTop);
      };

      const isFilterDrawerOpen = () => {
        return document.documentElement.classList.contains('c-filter-drawer-open')
          || Boolean(document.querySelector('.collection-filter .filter-wrapper.is-active'));
      };

      const updateHeader = () => {
        const scrollY = window.scrollY;
        const headerHeight = siteHeader.offsetHeight || 100;
        const heroBottom = getHeroBottom();
        const overHero = isHomeHeader && hero && scrollY < Math.max(heroBottom - headerHeight, 0);
        const scrollDelta = scrollY - lastScrollY;
        const scrollingDown = scrollDelta > 4;
        const scrollingUp = scrollDelta < 0;
        const shouldFixHeader = (isHomeHeader && !overHero) || (!isHomeHeader && scrollY > headerHeight);
        const filterDrawerOpen = isFilterDrawerOpen();
        const shouldKeepHeaderVisible = !filterDrawerOpen && (isPointerInsideHeader || wrapper.classList.contains(dropdownOpenClass) || hasOpenDropdown());

        setHeaderFixed(shouldFixHeader, headerHeight);
        wrapper.classList.toggle('c-header-wrapper--transparent', overHero);
        wrapper.classList.toggle('c-header-wrapper--solid', !overHero);

        if (overHero || scrollY <= headerHeight) {
          isHeaderRevealed = false;
          setHeaderHidden(false);
        } else if (filterDrawerOpen) {
          isHeaderRevealed = false;
          setHeaderHidden(true, true);
        } else if (shouldKeepHeaderVisible) {
          setHeaderHidden(false);
        } else if (scrollingUp) {
          isHeaderRevealed = true;
          setHeaderHidden(false);
        } else if (scrollingDown) {
          isHeaderRevealed = false;
          setHeaderHidden(true, true);
        } else if (!hasUpdatedHeader) {
          isHeaderRevealed = false;
          setHeaderHidden(true, true);
        }

        setCollectionFilterStickyTop(shouldFixHeader && !isHeaderHidden && !filterDrawerOpen, headerHeight);

        hasUpdatedHeader = true;
        lastScrollY = Math.max(scrollY, 0);
        ticking = false;
      };

      const requestUpdate = () => {
        if (ticking) {
          return;
        }

        ticking = true;
        window.requestAnimationFrame(updateHeader);
      };

      const isDesktopNavigation = () => {
        if (!desktopNav) {
          return true;
        }

        return window.getComputedStyle(desktopNav).display !== 'none';
      };

      const getDropdownTrigger = (item) => {
        return item.querySelector('.site-nav__link--has-dropdown');
      };

      const getDropdownItems = () => {
        return wrapper.querySelectorAll(dropdownItemSelector);
      };

      const getClosestFromTarget = (target, selector) => {
        const element = target && target.closest ? target : target && target.parentElement;

        if (!element || !element.closest) {
          return null;
        }

        return element.closest(selector);
      };

      const getDropdownItemFromTarget = (target) => {
        return getClosestFromTarget(target, dropdownItemSelector);
      };

      const getDropdownTriggerFromTarget = (target) => {
        return getClosestFromTarget(target, '.site-nav__link--has-dropdown');
      };

      const setDropdownExpanded = (item, expanded, keepOpenByClick) => {
        const trigger = getDropdownTrigger(item);

        item.classList.toggle('is-focused', expanded);
        item.classList.toggle(clickOpenClass, expanded && keepOpenByClick);

        if (expanded && keepOpenByClick) {
          item.setAttribute(clickOpenAttribute, 'true');
        } else if (!expanded) {
          item.removeAttribute(clickOpenAttribute);
        }

        if (trigger) {
          trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        }
      };

      const closeClickedDropdowns = (exceptItem) => {
        getDropdownItems().forEach((item) => {
          if (item !== exceptItem) {
            setDropdownExpanded(item, false);
          }
        });
      };

      const openDropdownState = () => {
        const headerHeight = siteHeader.offsetHeight || 100;

        wrapper.classList.add(dropdownOpenClass);
        setHeaderHidden(false);
        setCollectionFilterStickyTop(wrapper.classList.contains(fixedClass), headerHeight);
        lastScrollY = Math.max(window.scrollY, 0);
      };

      const closeDropdownState = () => {
        window.setTimeout(() => {
          if (!hasOpenDropdown()) {
            wrapper.classList.remove(dropdownOpenClass);
            requestUpdate();
          }
        }, 0);
      };

      const closeAllDropdowns = () => {
        closeClickedDropdowns();
        wrapper.classList.remove(dropdownOpenClass);
        requestUpdate();
      };

      const keepDropdownExpanded = (item) => {
        setDropdownExpanded(item, true, true);
        openDropdownState();

        window.setTimeout(() => {
          if (item.getAttribute(clickOpenAttribute) === 'true') {
            setDropdownExpanded(item, true, true);
            openDropdownState();
          }
        }, 0);
      };

      const hasOpenDropdown = () => {
        return Array.prototype.some.call(getDropdownItems(), (item) => {
          return item.getAttribute(clickOpenAttribute) === 'true'
            || item.matches(':hover')
            || item.classList.contains('is-focused')
            || item.contains(document.activeElement);
        });
      };

      const handleDropdownTriggerClick = (event) => {
        const trigger = getDropdownTriggerFromTarget(event.target);

        if (!trigger || !wrapper.contains(trigger) || !isDesktopNavigation()) {
          return;
        }

        const item = trigger.closest(dropdownItemSelector);

        if (!item) {
          return;
        }

        const isClickOpen = item.getAttribute(clickOpenAttribute) === 'true';

        event.preventDefault();
        event.stopPropagation();

        if (event.stopImmediatePropagation) {
          event.stopImmediatePropagation();
        }

        if (isClickOpen) {
          closeAllDropdowns();
          return;
        }

        closeClickedDropdowns(item);
        keepDropdownExpanded(item);
      };

      wrapper.addEventListener('click', handleDropdownTriggerClick, true);
      wrapper.addEventListener('touchend', handleDropdownTriggerClick, true);
      wrapper.addEventListener('pointerenter', () => {
        const headerHeight = siteHeader.offsetHeight || 100;

        isPointerInsideHeader = true;
        setHeaderHidden(false);
        setCollectionFilterStickyTop(wrapper.classList.contains(fixedClass), headerHeight);
        lastScrollY = Math.max(window.scrollY, 0);
      });
      wrapper.addEventListener('pointerleave', () => {
        isPointerInsideHeader = false;
        closeDropdownState();
      });

      getDropdownItems().forEach((item) => {
        item.addEventListener('mouseenter', () => {
          closeClickedDropdowns(item);
          setDropdownExpanded(item, true, item.getAttribute(clickOpenAttribute) === 'true');
          openDropdownState();
        });
        item.addEventListener('focusin', () => {
          closeClickedDropdowns(item);
          setDropdownExpanded(item, true, item.getAttribute(clickOpenAttribute) === 'true');
          openDropdownState();
        });
        item.addEventListener('touchstart', openDropdownState, { passive: true });
        item.addEventListener('mouseleave', () => {
          if (item.getAttribute(clickOpenAttribute) !== 'true') {
            setDropdownExpanded(item, false);
          }

          closeDropdownState();
        });
        item.addEventListener('focusout', () => {
          window.setTimeout(() => {
            if (item.contains(document.activeElement)) {
              return;
            }

            if (item.getAttribute(clickOpenAttribute) !== 'true') {
              setDropdownExpanded(item, false);
            }

            closeDropdownState();
          }, 0);
        });
      });

      document.addEventListener('click', (event) => {
        const clickedDropdownItem = getDropdownItemFromTarget(event.target);

        if (!wrapper.contains(event.target) || !clickedDropdownItem) {
          closeAllDropdowns();
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closeAllDropdowns();
        }
      });

      document.addEventListener('page:loaded', initHeader);
      window.addEventListener('pagehide', closeAllDropdowns);
      window.addEventListener('pageshow', () => {
        closeAllDropdowns();
        requestUpdate();
      });

      updateHeader();
      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', () => {
        closeAllDropdowns();
        requestUpdate();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initHeader);
    } else {
      initHeader();
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target && event.target.querySelector('[data-c-header-wrapper]')) {
        const wrapper = event.target.querySelector('[data-c-header-wrapper]');
        wrapper.removeAttribute('data-c-header-initialized');
        initHeader();
      }
    });
  })();

  // Lock background scroll while the collection filter drawer is open.
  (function() {
    const html = document.documentElement;
    const body = document.body;
    const openClass = 'c-filter-drawer-open';
    const drawerSelector = '.collection-filter .filter-wrapper.is-active';
    let isLocked = false;
    let lockedScrollY = 0;
    let ticking = false;

    const hasOpenDrawer = () => Boolean(document.querySelector(drawerSelector));

    const lockScroll = () => {
      if (isLocked) {
        return;
      }

      lockedScrollY = window.scrollY || window.pageYOffset || 0;
      isLocked = true;
      html.classList.add(openClass);
      body.classList.add(openClass);
      body.style.position = 'fixed';
      body.style.top = `-${lockedScrollY}px`;
      body.style.left = '0';
      body.style.right = '0';
      body.style.width = '100%';
    };

    const unlockScroll = () => {
      if (!isLocked) {
        return;
      }

      const restoreScrollY = lockedScrollY;
      const previousScrollBehavior = html.style.scrollBehavior;

      isLocked = false;
      html.style.scrollBehavior = 'auto';
      html.classList.remove(openClass);
      body.classList.remove(openClass);
      body.style.position = '';
      body.style.top = '';
      body.style.left = '';
      body.style.right = '';
      body.style.width = '';
      window.scrollTo({
        top: restoreScrollY,
        left: 0,
        behavior: 'auto'
      });

      window.requestAnimationFrame(() => {
        window.scrollTo({
          top: restoreScrollY,
          left: 0,
          behavior: 'auto'
        });
        html.style.scrollBehavior = previousScrollBehavior;
      });
    };

    const syncScrollLock = () => {
      ticking = false;

      if (hasOpenDrawer()) {
        lockScroll();
      } else {
        unlockScroll();
      }
    };

    const requestSync = () => {
      if (ticking) {
        return;
      }

      ticking = true;
      window.requestAnimationFrame(syncScrollLock);
    };

    const initFilterDrawerScrollLock = () => {
      requestSync();
    };

    const observer = new MutationObserver(requestSync);

    if (body) {
      observer.observe(body, {
        attributes: true,
        attributeFilter: ['class'],
        childList: true,
        subtree: true
      });
    }

    document.addEventListener('filter:selected', requestSync);
    document.addEventListener('page:loaded', initFilterDrawerScrollLock);
    document.addEventListener('shopify:section:load', initFilterDrawerScrollLock);
    window.addEventListener('pagehide', unlockScroll);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFilterDrawerScrollLock);
    } else {
      initFilterDrawerScrollLock();
    }
  })();

  (function() {
    const sectionSelector = '.c-coaching-program-list';
    const programSelector = '.c-coaching-program-list__program';
    const stepsSelector = '[data-coaching-program-steps]';
    const dotsSelector = '[data-coaching-program-dots]';
    const dotSelector = '[data-coaching-program-dot]';
    const prevSelector = '[data-coaching-program-prev]';
    const nextSelector = '[data-coaching-program-next]';
    const initializedAttribute = 'data-coaching-program-dots-initialized';
    const sliderClass = 'c-coaching-program-list__program--slider';
    const spMediaQuery = window.matchMedia('(max-width: 768px)');

    const getSections = (root) => {
      if (root && root.matches && root.matches(sectionSelector)) {
        return [root];
      }

      return Array.from((root || document).querySelectorAll(sectionSelector));
    };

    const getVisibleCount = () => spMediaQuery.matches ? 1 : 5;

    const getMaxIndex = (items) => Math.max(0, items.length - getVisibleCount());

    const getScrollLeftForItem = (steps, item) => item.offsetLeft - steps.offsetLeft;

    const getActiveIndex = (steps, items, maxIndex) => {
      const scrollLeft = steps.scrollLeft;
      let activeIndex = 0;
      let closestDistance = Infinity;

      items.forEach((item, index) => {
        const distance = Math.abs(getScrollLeftForItem(steps, item) - scrollLeft);

        if (distance < closestDistance) {
          closestDistance = distance;
          activeIndex = index;
        }
      });

      return Math.min(activeIndex, maxIndex);
    };

    const updateDots = (steps, dots, maxIndex) => {
      const items = Array.from(steps.querySelectorAll('.c-coaching-program-list__step'));

      if (!items.length || !dots.length) {
        return;
      }

      const activeIndex = getActiveIndex(steps, items, maxIndex);

      dots.forEach((dot, index) => {
        const isVisible = index <= maxIndex;
        const isActive = index === activeIndex;

        dot.hidden = !isVisible;
        dot.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
        dot.classList.toggle('is-active', isActive);

        if (isActive && isVisible) {
          dot.setAttribute('aria-current', 'step');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    };

    const updateButton = (button, disabled, isSlider) => {
      if (!button) {
        return;
      }

      button.hidden = !isSlider;
      button.disabled = disabled || !isSlider;
      button.setAttribute('aria-hidden', isSlider ? 'false' : 'true');
    };

    const updateSliderState = (program, steps, dotsWrapper, dots, prevButton, nextButton) => {
      const items = Array.from(steps.querySelectorAll('.c-coaching-program-list__step'));
      const maxIndex = getMaxIndex(items);
      const isSlider = items.length > getVisibleCount();
      const activeIndex = getActiveIndex(steps, items, maxIndex);

      program.classList.toggle(sliderClass, isSlider);
      dotsWrapper.hidden = !isSlider;
      dotsWrapper.setAttribute('aria-hidden', isSlider ? 'false' : 'true');

      if (!isSlider) {
        steps.scrollLeft = 0;
      }

      updateDots(steps, dots, maxIndex);
      updateButton(prevButton, activeIndex <= 0, isSlider);
      updateButton(nextButton, activeIndex >= maxIndex, isSlider);
    };

    const initProgramDots = (program) => {
      const steps = program.querySelector(stepsSelector);
      const dotsWrapper = program.querySelector(dotsSelector);
      const prevButton = program.querySelector(prevSelector);
      const nextButton = program.querySelector(nextSelector);

      if (!steps || !dotsWrapper || steps.getAttribute(initializedAttribute) === 'true') {
        return;
      }

      const items = Array.from(steps.querySelectorAll('.c-coaching-program-list__step'));
      const dots = Array.from(dotsWrapper.querySelectorAll(dotSelector));

      if (items.length < 2 || dots.length < 2) {
        return;
      }

      let ticking = false;
      const requestUpdate = () => {
        if (ticking) {
          return;
        }

        ticking = true;
        window.requestAnimationFrame(() => {
          ticking = false;
          updateSliderState(program, steps, dotsWrapper, dots, prevButton, nextButton);
        });
      };

      const selectStep = (index) => {
        const maxIndex = getMaxIndex(items);
        const targetIndex = Math.max(0, Math.min(index, maxIndex));
        const item = items[targetIndex];

        if (!item) {
          return;
        }

        steps.scrollTo({
          left: getScrollLeftForItem(steps, item),
          behavior: 'smooth'
        });
      };

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          selectStep(index);
        });
      });

      if (prevButton) {
        prevButton.addEventListener('click', () => {
          selectStep(getActiveIndex(steps, items, getMaxIndex(items)) - 1);
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', () => {
          selectStep(getActiveIndex(steps, items, getMaxIndex(items)) + 1);
        });
      }

      steps.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);
      steps.setAttribute(initializedAttribute, 'true');
      updateSliderState(program, steps, dotsWrapper, dots, prevButton, nextButton);
    };

    const initCoachingProgramDots = (root) => {
      getSections(root).forEach((section) => {
        section.querySelectorAll(programSelector).forEach(initProgramDots);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initCoachingProgramDots(document));
    } else {
      initCoachingProgramDots(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      initCoachingProgramDots(event.target);
    });
  })();

  (function() {
    const hostSelector = '.gw-rv-main-widget-placeholder';
    const styleId = 'shigeta-growave-review-style';
    const reviewStyleVersion = 'figma-20260908-thumbnail-radius';
    const enhancedAttribute = 'data-shigeta-review-enhanced';
    const observerAttribute = 'data-shigeta-review-observed';
    const reviewDotsObservedAttribute = 'data-shigeta-review-dots-observed';
    const reviewNativeLoadAttribute = 'data-shigeta-review-native-load';
    const reviewInitialVisibleCount = 4;
    const reviewLoadStep = 4;
    let bodyObserver = null;
    let initReviewsFrame = null;

    const reviewStyle = `
      /* shigeta-review-style: figma-20260908-thumbnail-radius */
      :host {
        display: block;
        width: 100%;
        margin-right: auto;
        margin-left: auto;
        box-sizing: border-box;
        color: #58534d;
        --gw-rv-icon-starColor: #DDCFD0;
        --gw-rv-theme-primaryColor: #9f9b96;
        --gw-rv-widgets-button-color: #9f9b96;
        --gw-rv-widgets-button-highlight-color: #9f9b96;
        --gw-rv-widgets-button-font-color: #ffffff;
        --gw-text-primary: #58534d;
        --gw-text-secondary: #58534d;
        --gw-text-tertiary: #9f9b96;
        --gw-border-default: transparent;
        --gw-border-light: transparent;
        --gw-bg-fill-secondary: #faf7f4;
        --gw-p-border-radius-card: 0px;
      }

      :host *,
      :host *::before,
      :host *::after {
        box-sizing: border-box;
      }

      .reviews-general-theme {
        color: #58534d;
        font-family: "DNP ShueiGoGinStd", "Noto Sans JP", "Hiragino Kaku Gothic ProN", "Yu Gothic", sans-serif;
        --gw-rv-icon-starColor: #DDCFD0 !important;
        --gw-rv-theme-primaryColor: #9f9b96 !important;
        --gw-rv-widgets-button-color: #9f9b96 !important;
        --gw-rv-widgets-button-highlight-color: #9f9b96 !important;
      }

      .gw-rv-product-page-widget {
        display: grid !important;
        grid-template-columns: minmax(0, 1fr) auto;
        column-gap: 24px;
        row-gap: 16px;
        align-items: start;
        width: 100%;
        color: #58534d;
      }

      .gw-rv-product-page-widget > .gw-text--heading-lg,
      .shigeta-review-title {
        grid-column: 1;
        grid-row: 1;
        display: flex !important;
        align-items: baseline !important;
        gap: 8px !important;
        margin: 0 !important;
        padding: 0 !important;
        color: #58534d !important;
        font-family: "EB Garamond", serif;
        font-size: 28px !important;
        font-weight: 400 !important;
        line-height: 1 !important;
        letter-spacing: 0.03em !important;
      }

      .shigeta-review-count {
        color: #58534d !important;
        font-family: "DNP ShueiGoGinStd", "Noto Sans JP", "Hiragino Kaku Gothic ProN", "Yu Gothic", sans-serif;
        font-size: 15px !important;
        font-weight: 400 !important;
        line-height: 1.7 !important;
        letter-spacing: 0.03em !important;
      }

      .shigeta-review-rating-wrap {
        grid-column: 1;
        grid-row: 2;
        min-width: 0;
      }

      .gw-rv-product-page-widget__tabs,
      .gw-tabs__menu-container,
      .gw-tabs__body,
      .gw-tabs-panel,
      .gw-tabs-panel > div,
      .gw-rv-reviews-list-widget,
      .gw-rv-reviews-list-widget > .reviews-general-theme {
        display: contents !important;
      }

      .gw-tabs__menu-container:empty {
        display: none !important;
      }

      .gw-rv-list-header {
        display: flex !important;
        width: 100%;
        margin: 0 !important;
        padding: 0 !important;
      }

      .gw-rv-list-header__ai-summary,
      .gw-rv-total-rate__bars {
        display: none !important;
      }

      .gw-rv-total-rate {
        width: 100%;
        min-width: 0 !important;
      }

      .gw-rv-total-rate > .gw-inline-stack {
        display: flex !important;
        align-items: center !important;
        gap: 12px !important;
      }

      .gw-rv-total-rate .gw-text--heading-lg {
        color: #58534d !important;
        font-family: "SF Pro", -apple-system, BlinkMacSystemFont, "Helvetica Neue", Arial, sans-serif;
        font-size: 24px !important;
        font-weight: 274 !important;
        line-height: 1.6 !important;
        letter-spacing: 0 !important;
      }

      .gw-rv-total-rate .gw-text--body-lg {
        display: none !important;
      }

      .gw-rv-rating-stars {
        display: inline-flex !important;
        align-items: center !important;
        gap: 4px !important;
        color: #DDCFD0 !important;
        line-height: 0 !important;
      }

      .gw-rv-rating-stars__star {
        display: block !important;
        flex: 0 0 16px !important;
        width: 16px !important;
        height: 16px !important;
        color: #DDCFD0 !important;
      }

      .gw-rv-rating-stars__star,
      .gw-rv-rating-stars__star g,
      .gw-rv-rating-stars__star path {
        fill: #DDCFD0 !important;
      }

      .gw-rv-rating-stars__star svg {
        display: block !important;
        width: 16px !important;
        height: 16px !important;
      }

      .gw-rv-list-settings {
        display: contents !important;
      }

      .gw-rv-list-settings__content {
        display: contents !important;
      }

      .gw-rv-list-settings__button-group {
        grid-column: 2;
        grid-row: 2;
        justify-self: end;
        align-self: center;
        margin: 0 !important;
      }

      .gw-rv-list-settings__filter-sort {
        grid-column: 2;
        grid-row: 1;
        justify-self: end;
        align-self: center;
        margin: 0 !important;
      }

      .gw-rv-list-settings .gw-btn,
      .gw-rv-list-settings .gw-select__trigger {
        min-height: 0;
        padding: 0;
        border: 0 !important;
        border-radius: 0;
        background: transparent !important;
        background-color: transparent !important;
        box-shadow: none !important;
        color: #58534d !important;
        appearance: none;
      }

      .gw-rv-list-settings .gw-btn {
        text-decoration: none !important;
      }

      .gw-rv-list-settings__button-group .gw-btn,
      .gw-rv-list-settings__button-group .gw-btn:hover,
      .gw-rv-list-settings__button-group .gw-btn:focus,
      .gw-rv-list-settings__button-group .gw-btn:active {
        min-width: 0;
        min-height: 0;
        padding: 0 !important;
        border: 0 !important;
        background: transparent !important;
        background-color: transparent !important;
        box-shadow: none !important;
        color: #58534d !important;
      }

      .gw-rv-list-settings__button-group .gw-btn__label,
      .gw-rv-list-settings__button-group .gw-text {
        background: transparent !important;
        background-color: transparent !important;
        color: #58534d !important;
        text-decoration: underline;
        text-decoration-color: #58534d;
        text-underline-offset: 4px;
      }

      .gw-rv-list-settings .gw-btn__label,
      .gw-rv-list-settings .gw-text,
      .gw-rv-list-settings .gw-select__trigger {
        color: #58534d;
        font-family: "DNP ShueiGoGinStd", "Noto Sans JP", "Hiragino Kaku Gothic ProN", "Yu Gothic", sans-serif;
        font-size: 11px;
        font-weight: 400;
        line-height: 1.5;
        letter-spacing: 0.03em;
      }

      .gw-rv-list-settings .gw-select__trigger {
        display: inline-flex;
        align-items: center !important;
        gap: 8px !important;
      }

      .gw-rv-list-settings__filter-sort .gw-select,
      .gw-rv-list-settings__filter-sort .gw-select__trigger {
        width: auto !important;
      }

      .gw-rv-list-settings__filter-sort .gw-btn,
      .gw-rv-list-settings__filter-sort .gw-btn__label,
      .gw-rv-list-settings__filter-sort .gw-text,
      .gw-rv-list-settings__filter-sort .gw-select__trigger {
        text-decoration: none !important;
      }

      .gw-rv-list-settings__filter-sort svg {
        width: 24px !important;
        height: 24px !important;
        color: #58534d !important;
      }

      .gw-rv-list-settings__filter-sort svg path {
        stroke: currentColor !important;
      }

      .gw-rv-product-page-widget__images-slider-wrapper {
        display: none !important;
        height: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
        overflow: hidden !important;
      }

      .gw-tabs-panel > .gw-rv-product-page-widget__images-slider-wrapper,
      .gw-rv-product-page-widget .gw-rv-product-page-widget__images-slider-wrapper,
      .gw-rv-product-page-widget__images-slider-wrapper .gw-rv-reviews-images-slider,
      .gw-rv-reviews-images-slider {
        display: none !important;
        height: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
        overflow: hidden !important;
      }

      .gw-rv-reviews-images-slider__track {
        gap: 8px !important;
      }

      .gw-rv-reviews-images-slider__item {
        overflow: hidden;
        background: #faf7f4;
      }

      .gw-rv-grid__masonry-wrapper,
      .gw-masonry {
        grid-column: 1 / -1;
        grid-row: 3;
        display: block !important;
        width: 100% !important;
        margin-top: 24px !important;
      }

      .gw-rv-list {
        grid-column: 1 / -1;
        grid-row: 3;
        display: grid !important;
        grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
        gap: 40px !important;
        width: 100% !important;
        margin: 24px 0 0 !important;
        padding: 0 !important;
        list-style: none !important;
      }

      .gw-masonry__grid {
        display: grid !important;
        grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
        grid-auto-rows: auto !important;
        justify-content: start;
        gap: 40px !important;
        width: 100% !important;
        margin: 0 !important;
        padding: 0 !important;
        list-style: none !important;
      }

      .gw-masonry__item {
        display: block !important;
        width: 100% !important;
        min-width: 0 !important;
        grid-row: auto !important;
        grid-row-end: auto !important;
      }

      .gw-masonry__item[hidden] {
        display: none !important;
      }

      .gw-rv-item,
      .gw-rv-grid-item {
        width: 100% !important;
        min-width: 0;
        max-width: none;
        height: auto !important;
        border: 0 !important;
        border-radius: 0 !important;
        background: #faf7f4 !important;
        box-shadow: none !important;
        box-sizing: border-box;
        color: #58534d;
        overflow: hidden;
      }

      .gw-rv-item {
        display: block !important;
        padding: 32px !important;
        list-style: none !important;
      }

      .gw-rv-item:not(:only-child) {
        border-bottom: 0 !important;
      }

      .gw-rv-grid-item__content {
        width: 100%;
        height: 100%;
        padding: 32px !important;
        box-sizing: border-box;
      }

      .gw-rv-item > .gw-block-stack,
      .gw-rv-grid-item__content > .gw-block-stack {
        height: 100%;
        gap: 22px !important;
      }

      .gw-rv-item .gw-inline-stack,
      .gw-rv-grid-item .gw-inline-stack {
        width: 100%;
      }

      .gw-rv-item .gw-text,
      .gw-rv-item .gw-rv-toggle-vote,
      .gw-rv-grid-item .gw-text,
      .gw-rv-grid-item .gw-rv-toggle-vote {
        color: #58534d !important;
        font-family: "DNP ShueiGoGinStd", "Noto Sans JP", "Hiragino Kaku Gothic ProN", "Yu Gothic", sans-serif;
        font-size: 11px !important;
        font-weight: 400 !important;
        line-height: 1.5 !important;
        letter-spacing: 0.03em !important;
      }

      .gw-rv-item .gw-text--tone-subdued,
      .gw-rv-item .gw-text--tone-tertiary,
      .gw-rv-grid-item .gw-text--tone-subdued,
      .gw-rv-grid-item .gw-text--tone-tertiary {
        color: #9f9b96 !important;
      }

      .gw-rv-item [data-shigeta-imported-review="true"],
      .gw-rv-grid-item [data-shigeta-imported-review="true"] {
        display: none !important;
      }

      .gw-rv-item img,
      .gw-rv-grid-item img {
        display: block;
        width: 100%;
        aspect-ratio: 898 / 505;
        border-radius: 0 !important;
        object-fit: cover;
      }

      .gw-rv-item .gw-rv-item-image-list,
      .gw-rv-grid-item .gw-rv-item-image-list,
      .gw-rv-item .gw-product-thumbnail__content,
      .gw-rv-grid-item .gw-product-thumbnail__content,
      .gw-rv-item [class*="image"],
      .gw-rv-grid-item [class*="image"] {
        border-radius: 0 !important;
      }

      .gw-rv-item .shigeta-review-shop-reply,
      .gw-rv-grid-item .shigeta-review-shop-reply,
      .gw-rv-item [class*="reply"],
      .gw-rv-grid-item [class*="reply"],
      .gw-rv-item [class*="answer"],
      .gw-rv-grid-item [class*="answer"] {
        border-radius: 0 !important;
        background: #ffffff !important;
        background-color: #ffffff !important;
      }

      .gw-rv-item .gw-rv-toggle-vote,
      .gw-rv-grid-item .gw-rv-toggle-vote {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        padding: 0;
        color: #58534d;
      }

      .gw-rv-item .gw-rv-rating-stars,
      .gw-rv-grid-item .gw-rv-rating-stars {
        gap: 2px;
      }

      .gw-rv-item .gw-view-more,
      .gw-rv-grid-item .gw-view-more {
        display: flex !important;
        flex-direction: column !important;
        gap: 8px !important;
        width: 100% !important;
        --gw-view-more-line-height: 16.5px !important;
        --gw-view-more-lines: 4 !important;
      }

      .gw-rv-item .gw-view-more__content,
      .gw-rv-grid-item .gw-view-more__content {
        display: block !important;
        height: auto !important;
        max-height: none !important;
        overflow: visible !important;
        line-height: 16.5px !important;
        -webkit-line-clamp: unset !important;
        line-clamp: unset !important;
      }

      .gw-rv-item .shigeta-review-view-more--has-button .gw-view-more__content,
      .gw-rv-grid-item .shigeta-review-view-more--has-button .gw-view-more__content {
        display: -webkit-box !important;
        max-height: calc(16.5px * var(--gw-view-more-lines)) !important;
        overflow: hidden !important;
        -webkit-box-orient: vertical !important;
        -webkit-line-clamp: var(--gw-view-more-lines) !important;
        line-clamp: var(--gw-view-more-lines) !important;
      }

      .gw-rv-item .gw-view-more__content--expanded,
      .gw-rv-grid-item .gw-view-more__content--expanded {
        max-height: none !important;
        -webkit-line-clamp: unset !important;
        line-clamp: unset !important;
      }

      .gw-rv-item .gw-view-more__button-container,
      .gw-rv-grid-item .gw-view-more__button-container {
        float: none !important;
        display: flex !important;
        align-items: center !important;
        justify-content: flex-end !important;
        width: 100% !important;
        height: auto !important;
        margin: 0 !important;
        padding: 0 !important;
        background: transparent !important;
        line-height: 1.5 !important;
        shape-outside: none !important;
      }

      .gw-rv-item .gw-view-more__button-container .gw-btn,
      .gw-rv-grid-item .gw-view-more__button-container .gw-btn {
        min-width: 0 !important;
        min-height: 0 !important;
        padding: 0 !important;
        border: 0 !important;
        background: transparent !important;
        color: #58534d !important;
        box-shadow: none !important;
        font-family: "DNP ShueiGoGinStd", "Noto Sans JP", "Hiragino Kaku Gothic ProN", "Yu Gothic", sans-serif;
        font-size: 11px !important;
        font-weight: 400 !important;
        line-height: 1.5 !important;
        letter-spacing: 0.03em !important;
        text-decoration: underline;
        text-decoration-color: #58534d;
        text-underline-offset: 4px;
      }

      .shigeta-review-author-row {
        display: none !important;
      }

      .shigeta-review-footer {
        display: flex !important;
        align-items: center !important;
        justify-content: space-between !important;
        gap: 12px !important;
        width: 100%;
      }

      .shigeta-review-footer-author {
        margin-left: auto;
        color: #9f9b96 !important;
        font-family: "DNP ShueiGoGinStd", "Noto Sans JP", "Hiragino Kaku Gothic ProN", "Yu Gothic", sans-serif;
        font-size: 11px;
        font-weight: 400;
        line-height: 1.5;
        letter-spacing: 0.03em;
        white-space: nowrap;
      }

      .gw-rv-reviews-list-widget__load-more-btn-wrapper {
        grid-column: 1 / -1;
        grid-row: 4;
        display: flex !important;
        justify-content: center !important;
        margin-top: 8px !important;
      }

      .gw-rv-reviews-list-widget__load-more-btn-wrapper .gw-btn,
      .gw-rv-reviews-list-widget__load-more-btn-wrapper .gw-btn:hover,
      .gw-rv-reviews-list-widget__load-more-btn-wrapper .gw-btn:focus,
      .gw-rv-reviews-list-widget__load-more-btn-wrapper .gw-btn:active {
        min-width: 0 !important;
        min-height: 0 !important;
        padding: 0 !important;
        border: 0 !important;
        border-radius: 0 !important;
        background: transparent !important;
        background-color: transparent !important;
        box-shadow: none !important;
        color: #58534d !important;
        text-decoration: underline !important;
        text-decoration-color: #58534d !important;
        text-decoration-thickness: 1px !important;
        text-underline-offset: 4px !important;
        text-decoration-skip-ink: none !important;
      }

      .gw-rv-reviews-list-widget__load-more-btn-wrapper .gw-text,
      .gw-rv-reviews-list-widget__load-more-btn-wrapper .gw-btn__label {
        color: #58534d !important;
        font-family: "DNP ShueiGoGinStd", "Noto Sans JP", "Hiragino Kaku Gothic ProN", "Yu Gothic", sans-serif;
        font-size: 11px !important;
        font-weight: 400 !important;
        line-height: 1.5 !important;
        letter-spacing: 0.03em !important;
        text-decoration: inherit !important;
        text-decoration-color: inherit !important;
        text-decoration-thickness: inherit !important;
        text-underline-offset: inherit !important;
      }

      .gw-rv-reviews-list-widget__load-more-btn-wrapper svg {
        display: none !important;
      }

      .gw-brand {
        display: none !important;
      }

      .shigeta-review-dots {
        display: none;
      }

      @media (min-width: 769px) and (max-width: 1024px) {
        .gw-rv-list,
        .gw-masonry__grid {
          grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
          gap: 32px !important;
        }
      }

      @media (max-width: 768px) {
        .gw-rv-product-page-widget {
          display: grid !important;
          grid-template-columns: minmax(0, 1fr) auto;
          row-gap: 16px;
        }

        .gw-rv-product-page-widget > .gw-text--heading-lg {
          grid-column: 1 / -1;
          grid-row: 1;
          flex-wrap: nowrap;
          font-size: 28px !important;
        }

        .shigeta-review-count {
          font-size: 15px !important;
        }

        .gw-rv-list-header {
          margin-top: 0;
        }

        .gw-rv-total-rate > .gw-inline-stack {
          gap: 10px;
        }

        .shigeta-review-rating-wrap {
          grid-column: 1;
          grid-row: 3;
        }

        .gw-rv-list-settings {
          display: contents !important;
        }

        .gw-rv-list-settings__button-group {
          grid-column: 2;
          grid-row: 3;
          justify-self: end;
          align-self: center;
        }

        .gw-rv-list-settings__filter-sort {
          grid-column: 1 / -1;
          grid-row: 2;
          justify-self: start;
          margin-top: -12px !important;
        }

        .gw-rv-grid__masonry-wrapper,
        .gw-masonry {
          grid-column: 1 / -1;
          grid-row: 4;
          margin-top: 8px !important;
        }

        .gw-rv-product-page-widget__images-slider-wrapper {
          display: none !important;
        }

        .gw-rv-list {
          grid-column: 1 / -1;
          grid-row: 4;
          display: grid !important;
          grid-template-columns: minmax(0, 1fr) !important;
          gap: 24px !important;
          width: 100% !important;
          max-width: none !important;
          margin: 8px 0 0 !important;
          padding: 0 !important;
          overflow: visible !important;
          scroll-snap-type: none;
        }

        .gw-rv-list::-webkit-scrollbar {
          display: none;
        }

        .gw-masonry__grid {
          display: grid !important;
          grid-template-columns: minmax(0, 1fr) !important;
          gap: 24px !important;
          width: 100% !important;
          max-width: none !important;
          margin-inline: 0 !important;
          padding: 0 !important;
          overflow: visible !important;
          scroll-snap-type: none;
        }

        .gw-masonry__grid::-webkit-scrollbar {
          display: none;
        }

        .gw-masonry__item {
          flex: none;
          width: 100% !important;
          scroll-snap-align: none;
        }

        .gw-rv-item {
          flex: none;
          width: 100% !important;
          padding: 32px !important;
          scroll-snap-align: none;
        }

        .gw-rv-grid-item {
          flex: none;
          scroll-snap-align: none;
        }

        .shigeta-review-dots {
          display: none !important;
        }

        .shigeta-review-dot {
          width: 6px;
          height: 6px;
          padding: 0;
          border: 0;
          border-radius: 999px;
          background: #ece7e2;
        }

        .shigeta-review-dot.is-active {
          background: #9f9b96;
        }

        .gw-rv-reviews-list-widget__load-more-btn-wrapper {
          grid-column: 1 / -1;
          grid-row: 5;
        }
      }
    `;

    const getReviewRoot = (host) => host && host.shadowRoot ? host.shadowRoot : null;

    const getReviewState = (root) => {
      if (!root.__shigetaReviewState) {
        root.__shigetaReviewState = {
          visibleCount: reviewInitialVisibleCount,
          isLoading: false
        };
      }

      return root.__shigetaReviewState;
    };

    const getReviewItems = (root) => {
      const masonryGrid = root.querySelector('.gw-masonry__grid');

      if (masonryGrid) {
        return Array.from(masonryGrid.children).filter((element) => (
          element.classList.contains('gw-rv-grid-item') || element.querySelector('.gw-rv-grid-item')
        ));
      }

      const reviewList = root.querySelector('.gw-rv-list');

      if (reviewList) {
        return Array.from(reviewList.children).filter((element) => (
          element.classList.contains('gw-rv-item') || element.querySelector('.gw-rv-item')
        ));
      }

      return Array.from(root.querySelectorAll('.gw-rv-grid-item'));
    };

    const getNativeReviewLoadButton = (root) => (
      root.querySelector('.gw-rv-reviews-list-widget__load-more-btn-wrapper button')
    );

    const getWidgetDirectChild = (widget, descendant) => {
      if (!widget || !descendant) {
        return null;
      }

      let element = descendant;

      while (element && element.parentElement !== widget) {
        element = element.parentElement;
      }

      return element && element.parentElement === widget ? element : null;
    };

    const getReviewCount = (root) => {
      const countText = Array.from(root.querySelectorAll('.gw-text')).find((element) => (
        /[0-9]+のレビューに基づく/.test(element.textContent || '')
      ));
      const count = countText && countText.textContent ? countText.textContent.match(/[0-9]+/) : null;

      return count ? count[0] : '';
    };

    const normalizeDate = (text) => text.replace(/([0-9]{4})年([0-9]{1,2})月([0-9]{1,2})日/g, '$1/$2/$3');

    const enhanceReviewLayout = (root) => {
      const widget = root.querySelector('.gw-rv-product-page-widget');
      const ratingHeader = root.querySelector('.gw-rv-list-header');
      const ratingWrap = getWidgetDirectChild(widget, ratingHeader);

      if (ratingWrap) {
        ratingWrap.classList.add('shigeta-review-rating-wrap');
      }
    };

    const updateReviewHeading = (heading, count) => {
      if (!heading) {
        return;
      }

      heading.classList.add('shigeta-review-title');

      let countElement = heading.querySelector('.shigeta-review-count');

      if (!countElement) {
        heading.textContent = 'Reviews';
        countElement = document.createElement('span');
        countElement.className = 'shigeta-review-count';
        heading.appendChild(countElement);
      } else {
        const textNode = Array.from(heading.childNodes).find((node) => node.nodeType === 3);

        if (textNode && textNode.textContent !== 'Reviews') {
          textNode.textContent = 'Reviews';
        } else if (!textNode) {
          heading.insertBefore(document.createTextNode('Reviews'), countElement);
        }
      }

      if (count) {
        const countText = `（${count}件）`;

        if (countElement.textContent !== countText) {
          countElement.textContent = countText;
        }

        countElement.removeAttribute('hidden');
      } else {
        countElement.setAttribute('hidden', 'hidden');
      }

      heading.setAttribute(enhancedAttribute, 'true');
    };

    const normalizeReviewViewMore = (card) => {
      card.querySelectorAll('.gw-view-more').forEach((viewMore) => {
        const content = viewMore.querySelector(':scope > .gw-view-more__content');
        const buttonContainer = viewMore.querySelector(':scope > .gw-view-more__button-container') || (content ? content.querySelector(':scope > .gw-view-more__button-container') : null);

        viewMore.classList.toggle('shigeta-review-view-more--has-button', Boolean(buttonContainer));

        if (content && buttonContainer && buttonContainer.parentElement === content) {
          viewMore.appendChild(buttonContainer);
        }
      });
    };

    const normalizeReviewReplies = (card) => {
      card.querySelectorAll('.shigeta-review-shop-reply').forEach((element) => {
        element.classList.remove('shigeta-review-shop-reply');
      });

      const hasVisibleBackground = (color) => color && color !== 'transparent' && color !== 'rgba(0, 0, 0, 0)';

      Array.from(card.querySelectorAll('div, p, span')).forEach((element) => {
        const text = (element.textContent || '').trim();

        if (!/^ショップ返信(\s|$)/.test(text) && !/^Shop reply/i.test(text) && !/^Store reply/i.test(text)) {
          return;
        }

        let container = element;
        let replyContainer = null;

        while (container.parentElement && container.parentElement !== card) {
          const className = typeof container.className === 'string' ? container.className.toLowerCase() : '';
          const computedStyle = window.getComputedStyle(container);
          const hasRadius = parseFloat(computedStyle.borderTopLeftRadius) > 0 || parseFloat(computedStyle.borderTopRightRadius) > 0 || parseFloat(computedStyle.borderBottomRightRadius) > 0 || parseFloat(computedStyle.borderBottomLeftRadius) > 0;

          if (className.includes('reply') || className.includes('answer') || hasRadius || hasVisibleBackground(computedStyle.backgroundColor)) {
            replyContainer = container;
            break;
          }

          container = container.parentElement;
        }

        if (!replyContainer && element.parentElement && element.parentElement !== card) {
          replyContainer = element.parentElement;
        }

        if (!replyContainer || replyContainer === card || replyContainer.classList.contains('gw-rv-grid-item__content')) {
          return;
        }

        replyContainer.classList.add('shigeta-review-shop-reply');
      });
    };

    const enhanceReviewCards = (root) => {
      root.querySelectorAll('.gw-rv-grid-item, .gw-rv-item').forEach((card) => {
        const contentStack = card.querySelector('.gw-rv-grid-item__content > .gw-block-stack') || card.querySelector(':scope > .gw-block-stack');

        if (!contentStack) {
          return;
        }

        normalizeReviewViewMore(card);
        normalizeReviewReplies(card);

        const rows = Array.from(contentStack.children);
        const contentBody = rows.find((row) => row.querySelector('.gw-rv-toggle-vote') || row.querySelector('.gw-view-more') || row.querySelector('.gw-rv-item-image-list'));
        const nestedContent = contentBody ? Array.from(contentBody.children).find((row) => row.matches && row.matches('.gw-block-stack')) : null;
        const nestedAuthorRow = nestedContent ? Array.from(nestedContent.children).find((row) => (
          !row.querySelector('.gw-rv-toggle-vote') && !row.querySelector('.gw-view-more') && (row.textContent || '').trim().length <= 30
        )) : null;
        const directAuthorRow = rows[1] && !rows[1].querySelector('.gw-rv-toggle-vote') && (rows[1].textContent || '').trim().length <= 30
          ? rows[1]
          : null;
        const authorRow = nestedAuthorRow || directAuthorRow;
        const footerSource = contentBody || contentStack;
        const footerRow = Array.from(footerSource.children).find((row) => row.querySelector('.gw-rv-toggle-vote'));
        const authorText = authorRow ? (authorRow.textContent || '').trim() : '';

        if (authorRow && authorText) {
          authorRow.classList.add('shigeta-review-author-row');
        }

        if (!footerRow || !authorText) {
          return;
        }

        footerRow.classList.add('shigeta-review-footer');

        let footerAuthor = footerRow.querySelector('.shigeta-review-footer-author');

        if (!footerAuthor) {
          footerAuthor = document.createElement('span');
          footerAuthor.className = 'shigeta-review-footer-author';
          footerRow.appendChild(footerAuthor);
        }

        if (footerAuthor.textContent !== authorText) {
          footerAuthor.textContent = authorText;
        }
      });
    };

    const enhanceReviewContent = (root) => {
      const count = getReviewCount(root);
      const heading = Array.from(root.querySelectorAll('.gw-rv-product-page-widget > .gw-text--heading-lg')).find((element) => (
        /カスタマーレビュー|Reviews/.test(element.textContent || '')
      ));

      updateReviewHeading(heading, count);

      root.querySelectorAll('[data-shigeta-imported-review="true"]').forEach((element) => {
        element.removeAttribute('data-shigeta-imported-review');
      });

      root.querySelectorAll('.gw-rv-grid-item .gw-text, .gw-rv-grid-item p, .gw-rv-item .gw-text, .gw-rv-item p').forEach((element) => {
        if (/^[0-9]{4}年[0-9]{1,2}月[0-9]{1,2}日$/.test(element.textContent.trim())) {
          element.textContent = normalizeDate(element.textContent.trim());
        }

        if ((element.textContent || '').trim() === 'レビューをインポートしました') {
          const parent = element.closest('.gw-inline-stack') || element;

          if (parent) {
            parent.setAttribute('data-shigeta-imported-review', 'true');
          }
        }
      });

      enhanceReviewCards(root);
    };

    const applyReviewVisibleLimit = (root) => {
      const state = getReviewState(root);
      const items = getReviewItems(root);
      const reviewCount = Number(getReviewCount(root));
      const nativeButton = getNativeReviewLoadButton(root);
      const loadMoreWrapper = root.querySelector('.gw-rv-reviews-list-widget__load-more-btn-wrapper');

      items.forEach((item, index) => {
        item.toggleAttribute('hidden', index >= state.visibleCount);
      });

      if (!loadMoreWrapper) {
        return;
      }

      const hasHiddenItems = items.length > state.visibleCount;
      const hasMoreReviews = reviewCount ? state.visibleCount < reviewCount : !!nativeButton;

      loadMoreWrapper.toggleAttribute('hidden', !hasHiddenItems && !hasMoreReviews);
    };

    const requestNativeReviewLoad = (root) => {
      const state = getReviewState(root);
      const button = getNativeReviewLoadButton(root);

      if (!button || state.isLoading || button.disabled) {
        return;
      }

      state.isLoading = true;
      button.setAttribute(reviewNativeLoadAttribute, 'true');
      button.click();

      window.setTimeout(() => {
        button.removeAttribute(reviewNativeLoadAttribute);
        state.isLoading = false;
        ensureReviewItemsLoaded(root);
      }, 800);
    };

    const ensureReviewItemsLoaded = (root) => {
      const state = getReviewState(root);
      const items = getReviewItems(root);

      applyReviewVisibleLimit(root);

      if (items.length < state.visibleCount && getNativeReviewLoadButton(root)) {
        requestNativeReviewLoad(root);
      }
    };

    const setupReviewLoadMore = (root) => {
      const button = getNativeReviewLoadButton(root);

      if (!button || button.getAttribute(enhancedAttribute) === 'true') {
        ensureReviewItemsLoaded(root);
        return;
      }

      button.setAttribute(enhancedAttribute, 'true');
      button.addEventListener('click', (event) => {
        if (button.getAttribute(reviewNativeLoadAttribute) === 'true') {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        if (event.stopImmediatePropagation) {
          event.stopImmediatePropagation();
        }

        const state = getReviewState(root);
        state.visibleCount += reviewLoadStep;
        ensureReviewItemsLoaded(root);
      }, true);

      ensureReviewItemsLoaded(root);
    };

    const removeReviewDots = (root) => {
      root.querySelectorAll('.shigeta-review-dots').forEach((element) => {
        element.remove();
      });

      root.querySelectorAll('[data-shigeta-review-dot-count]').forEach((element) => {
        element.removeAttribute('data-shigeta-review-dot-count');
      });
    };

    const updateReviewDots = (scrollElement, dots) => {
      const items = Array.from(scrollElement.children).filter((element) => !element.hasAttribute('hidden')).map((element) => (
        element.classList.contains('gw-rv-grid-item') || element.classList.contains('gw-rv-item')
          ? element
          : element.querySelector('.gw-rv-grid-item, .gw-rv-item')
      )).filter(Boolean);
      const firstItem = items[0];

      if (!firstItem) {
        return;
      }

      const gap = parseFloat(window.getComputedStyle(scrollElement).columnGap || window.getComputedStyle(scrollElement).gap) || 24;
      const itemWidth = firstItem.getBoundingClientRect().width + gap;
      const activeIndex = Math.max(0, Math.min(dots.length - 1, Math.round(scrollElement.scrollLeft / itemWidth)));

      dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === activeIndex);
      });
    };

    const setupReviewDots = (root) => {
      const scrollElement = root.querySelector('.gw-masonry__grid') || root.querySelector('.gw-rv-list') || root.querySelector('.gw-rv-grid__masonry-wrapper');

      if (!scrollElement) {
        return;
      }

      const items = Array.from(scrollElement.children).filter((element) => (
        element.classList.contains('gw-rv-grid-item') || element.classList.contains('gw-rv-item') || element.querySelector('.gw-rv-grid-item, .gw-rv-item')
      )).filter((element) => !element.hasAttribute('hidden'));

      if (items.length < 2) {
        return;
      }

      const dotCount = String(items.length);
      const currentDotsWrapper = root.querySelector('.shigeta-review-dots');

      if (scrollElement.getAttribute('data-shigeta-review-dot-count') === dotCount && currentDotsWrapper) {
        updateReviewDots(scrollElement, Array.from(currentDotsWrapper.querySelectorAll('.shigeta-review-dot')));
        return;
      }

      if (currentDotsWrapper) {
        currentDotsWrapper.remove();
      }

      const dotsWrapper = document.createElement('div');
      dotsWrapper.className = 'shigeta-review-dots';

      const dots = items.map((item, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'shigeta-review-dot';
        dot.setAttribute('aria-label', `${index + 1}件目のレビューへ移動`);
        dot.addEventListener('click', () => {
          scrollElement.scrollTo({
            left: item.offsetLeft - scrollElement.offsetLeft,
            behavior: 'smooth'
          });
        });
        dotsWrapper.appendChild(dot);

        return dot;
      });

      scrollElement.insertAdjacentElement('afterend', dotsWrapper);
      scrollElement.setAttribute('data-shigeta-review-dot-count', dotCount);
      updateReviewDots(scrollElement, dots);

      if (scrollElement.getAttribute(reviewDotsObservedAttribute) !== 'true') {
        scrollElement.setAttribute(reviewDotsObservedAttribute, 'true');
        scrollElement.addEventListener('scroll', () => {
          const activeDotsWrapper = root.querySelector('.shigeta-review-dots');

          if (!activeDotsWrapper) {
            return;
          }

          updateReviewDots(scrollElement, Array.from(activeDotsWrapper.querySelectorAll('.shigeta-review-dot')));
        }, { passive: true });
      }
    };

    const enhanceReviewHost = (host) => {
      const root = getReviewRoot(host);

      if (!root) {
        return false;
      }

      if (host.getAttribute('data-shigeta-review-style-version') !== reviewStyleVersion && root.__shigetaReviewState) {
        root.__shigetaReviewState.visibleCount = reviewInitialVisibleCount;
        root.__shigetaReviewState.isLoading = false;
      }

      host.setAttribute('data-shigeta-review-style-version', reviewStyleVersion);

      let style = root.getElementById(styleId);

      if (!style) {
        style = document.createElement('style');
        style.id = styleId;
      }

      if (style.textContent !== reviewStyle) {
        style.textContent = reviewStyle;
      }

      if (style.parentNode !== root || style.nextSibling) {
        root.appendChild(style);
      }

      enhanceReviewLayout(root);
      enhanceReviewContent(root);
      setupReviewLoadMore(root);
      removeReviewDots(root);

      return true;
    };

    const initReviews = () => {
      let hasEnhancedHost = false;

      document.querySelectorAll(hostSelector).forEach((host) => {
        if (!enhanceReviewHost(host)) {
          return;
        }

        hasEnhancedHost = true;

        if (host.getAttribute(observerAttribute) === 'true') {
          return;
        }

        host.setAttribute(observerAttribute, 'true');

        const root = getReviewRoot(host);

        if (!root) {
          return;
        }

        const observer = new MutationObserver(() => {
          enhanceReviewHost(host);
        });

        observer.observe(root, { childList: true, subtree: true, characterData: true });
      });

      if (hasEnhancedHost && bodyObserver) {
        bodyObserver.disconnect();
        bodyObserver = null;
      }
    };

    const scheduleInitReviews = () => {
      if (initReviewsFrame) {
        return;
      }

      initReviewsFrame = window.requestAnimationFrame(() => {
        initReviewsFrame = null;
        initReviews();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initReviews);
    } else {
      initReviews();
    }

    window.addEventListener('load', scheduleInitReviews);
    document.addEventListener('shopify:section:load', scheduleInitReviews);

    bodyObserver = new MutationObserver(scheduleInitReviews);
    bodyObserver.observe(document.documentElement, { childList: true, subtree: true });
  })();

  // Product detail fixed conversion bar.
  (function() {
    const stickySelector = '[data-product-sticky-conversion]';
    const initializedAttribute = 'data-product-sticky-initialized';
    const visibleClass = 'is-visible';
    const stickyStates = [];
    let visibilityFrame = null;
    let visibilityListenersInitialized = false;

    const getStickyBars = (root) => {
      if (root && root.matches && root.matches(stickySelector)) {
        return [root];
      }

      return Array.from((root || document).querySelectorAll(stickySelector));
    };

    const normalizeQuantity = (value) => {
      const quantity = parseInt(value, 10);

      if (!quantity || quantity < 1) {
        return '1';
      }

      return String(quantity);
    };

    const updateStickyQuantity = (input, value) => {
      const normalizedValue = normalizeQuantity(value);
      if (!input) {
        return;
      }

      input.value = normalizedValue;
    };

    const getMainQuantity = (form) => {
      if (!form || !form.id) {
        return null;
      }

      return Array.from(document.querySelectorAll('.product-block--quantity .js-qty__num')).find((input) => {
        return input.getAttribute('form') === form.id || input.form === form;
      }) || null;
    };

    const getFormQuantity = (form) => {
      if (!form) {
        return null;
      }

      let formQuantity = form.querySelector('[data-product-sticky-form-quantity]');

      if (!formQuantity) {
        formQuantity = document.createElement('input');
        formQuantity.type = 'hidden';
        formQuantity.name = 'quantity';
        formQuantity.setAttribute('data-product-sticky-form-quantity', '');
        form.appendChild(formQuantity);
      }

      return formQuantity;
    };

    const syncFormQuantity = (form, value) => {
      const formQuantity = getFormQuantity(form);

      if (!formQuantity) {
        return;
      }

      formQuantity.value = normalizeQuantity(value);
    };

    const syncMainQuantity = (sticky, mainQuantity, input) => {
      if (!input) {
        return;
      }

      const normalizedValue = normalizeQuantity(input.value);
      const form = sticky && sticky.dataset.mainFormId
        ? document.getElementById(sticky.dataset.mainFormId)
        : null;

      if (mainQuantity) {
        mainQuantity.value = normalizedValue;
        mainQuantity.dispatchEvent(new Event('change', { bubbles: true }));
      }

      syncFormQuantity(form, normalizedValue);
    };

    const changeStickyQuantity = (input, delta) => {
      if (!input) {
        return;
      }

      const currentQuantity = parseInt(input.value, 10) || 1;
      updateStickyQuantity(input, currentQuantity + delta);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    };

    const updateStickyButton = (sticky, variant) => {
      const button = sticky.querySelector('[data-product-sticky-submit]');
      const text = sticky.querySelector('[data-product-sticky-submit-text]');

      if (!button || !text) {
        return;
      }

      if (variant && variant.available) {
        button.disabled = false;
        text.textContent = sticky.dataset.defaultButtonText || text.textContent;
      } else if (variant) {
        button.disabled = true;
        text.textContent = sticky.dataset.soldOutText || text.textContent;
      } else {
        button.disabled = true;
        text.textContent = sticky.dataset.unavailableText || text.textContent;
      }
    };

    const updateStickyPrice = (sticky, variant) => {
      const price = sticky.querySelector('[data-product-sticky-price]');

      if (!price || !variant || typeof variant.price === 'undefined' || !window.theme || !theme.Currency) {
        return;
      }

      price.innerHTML = theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat);
    };

    const updateStickyImage = (sticky, variant) => {
      const image = sticky.querySelector('[data-product-sticky-image]');

      if (!image || !variant || !variant.featured_media || !variant.featured_media.preview_image) {
        return;
      }

      const imageSrc = variant.featured_media.preview_image.src;
      const sizedImageSrc = window.theme && theme.Images
        ? theme.Images.getSizedImageUrl(imageSrc, '108x108_crop_center')
        : imageSrc;

      image.src = sizedImageSrc;
    };

    const getFooter = () => document.querySelector('.site-footer');

    const setStickyVisibility = (sticky, shouldShow) => {
      sticky.classList.toggle(visibleClass, shouldShow);
      sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    };

    const updateStickyVisibility = () => {
      visibilityFrame = null;

      const footer = getFooter();
      const footerRect = footer ? footer.getBoundingClientRect() : null;
      const isFooterVisible = footerRect
        ? footerRect.top < window.innerHeight && footerRect.bottom > 0
        : false;

      for (let index = stickyStates.length - 1; index >= 0; index -= 1) {
        const state = stickyStates[index];
        const hasRemovedElements = !document.documentElement.contains(state.sticky)
          || !document.documentElement.contains(state.addToCartButton);

        if (hasRemovedElements) {
          stickyStates.splice(index, 1);
          continue;
        }

        const addToCartRect = state.addToCartButton.getBoundingClientRect();
        const hasPassedAddToCartButton = addToCartRect.bottom <= 0;

        setStickyVisibility(state.sticky, hasPassedAddToCartButton && !isFooterVisible);
      }
    };

    const requestStickyVisibilityUpdate = () => {
      if (visibilityFrame) {
        return;
      }

      visibilityFrame = window.requestAnimationFrame(updateStickyVisibility);
    };

    const initStickyVisibilityListeners = () => {
      if (visibilityListenersInitialized) {
        return;
      }

      visibilityListenersInitialized = true;
      window.addEventListener('scroll', requestStickyVisibilityUpdate, { passive: true });
      window.addEventListener('resize', requestStickyVisibilityUpdate);
      window.addEventListener('load', requestStickyVisibilityUpdate);
      document.addEventListener('shopify:section:load', requestStickyVisibilityUpdate);
    };

    const registerStickyVisibility = (sticky, addToCartButton) => {
      if (!addToCartButton) {
        setStickyVisibility(sticky, false);
        return;
      }

      if (!stickyStates.some((state) => state.sticky === sticky)) {
        stickyStates.push({
          sticky,
          addToCartButton
        });
      }

      initStickyVisibilityListeners();
      requestStickyVisibilityUpdate();
      window.setTimeout(requestStickyVisibilityUpdate, 300);
    };

    const initStickyConversion = (root) => {
      getStickyBars(root).forEach((sticky) => {
        if (sticky.getAttribute(initializedAttribute) === 'true') {
          return;
        }

        const form = document.getElementById(sticky.dataset.mainFormId);
        const productSection = sticky.closest('.product-section');
        const mainQuantity = getMainQuantity(form);
        const quantityInput = sticky.querySelector('[data-product-sticky-quantity]');
        const quantityMinus = sticky.querySelector('[data-product-sticky-quantity-minus]');
        const quantityPlus = sticky.querySelector('[data-product-sticky-quantity-plus]');
        const button = sticky.querySelector('[data-product-sticky-submit]');
        const addToCartButton = form ? form.querySelector('[data-add-to-cart], .add-to-cart') : null;

        if (!form || !quantityInput || !button) {
          return;
        }

        sticky.setAttribute(initializedAttribute, 'true');
        registerStickyVisibility(sticky, addToCartButton);

        if (mainQuantity) {
          updateStickyQuantity(quantityInput, mainQuantity.value);
        }

        quantityInput.addEventListener('change', () => {
          updateStickyQuantity(quantityInput, quantityInput.value);
          syncMainQuantity(sticky, mainQuantity, quantityInput);
        });

        if (quantityMinus) {
          quantityMinus.addEventListener('click', () => {
            changeStickyQuantity(quantityInput, -1);
          });
        }

        if (quantityPlus) {
          quantityPlus.addEventListener('click', () => {
            changeStickyQuantity(quantityInput, 1);
          });
        }

        if (mainQuantity) {
          mainQuantity.addEventListener('change', () => {
            updateStickyQuantity(quantityInput, mainQuantity.value);
            syncFormQuantity(form, mainQuantity.value);
          });

          const mainQuantityWrapper = mainQuantity.closest('.js-qty__wrapper');
          if (mainQuantityWrapper) {
            mainQuantityWrapper.addEventListener('click', () => {
              window.setTimeout(() => {
                updateStickyQuantity(quantityInput, mainQuantity.value);
                syncFormQuantity(form, mainQuantity.value);
              }, 0);
            });
          }
        }

        button.addEventListener('click', () => {
          syncMainQuantity(sticky, mainQuantity, quantityInput);
          button.classList.add('btn--loading');
        });

        form.addEventListener('submit', () => {
          const quantityValue = mainQuantity ? mainQuantity.value : quantityInput.value;
          syncFormQuantity(form, quantityValue);
          updateStickyQuantity(quantityInput, quantityValue);
        }, true);

        form.addEventListener('submit', () => {
          window.setTimeout(() => {
            button.classList.remove('btn--loading');
          }, 3000);
        });

        if (productSection) {
          productSection.addEventListener('variantChange', (event) => {
            const variant = event.detail && event.detail.variant;
            updateStickyButton(sticky, variant);
            updateStickyPrice(sticky, variant);
            updateStickyImage(sticky, variant);
          });
        }
      });
    };

    const clearStickyLoading = () => {
      document.querySelectorAll('[data-product-sticky-submit].btn--loading').forEach((button) => {
        button.classList.remove('btn--loading');
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initStickyConversion());
    } else {
      initStickyConversion();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initStickyConversion(event.target);
    });
    document.addEventListener('ajaxProduct:added', clearStickyLoading);
    document.addEventListener('ajaxProduct:error', clearStickyLoading);
  })();

  // Cart GWP: keep the gift block and the item count in sync with the cart.
  // Doctor Free Gift adds/removes the gift line asynchronously, so the block is
  // re-rendered through the Section Rendering API whenever the cart changes.
  (function() {
    const SELECTOR = '[data-cart-gwp]';
    const COUNT_SELECTOR = '.js-cart-page-count';
    const EMPTY_CLASS = 'c-cart--empty';
    const timers = [];
    let inflight = null;

    const getContainer = () => document.querySelector(SELECTOR);

    const refresh = () => {
      const container = getContainer();
      if (!container) {
        return;
      }

      const sectionId = container.dataset.sectionId;
      const sectionUrl = container.dataset.sectionUrl || window.location.pathname;
      if (!sectionId) {
        return;
      }

      const url = `${sectionUrl}?sections=${encodeURIComponent(sectionId)}&t=${Date.now()}`;
      const request = fetch(url, { credentials: 'same-origin' })
        .then((response) => (response.ok ? response.json() : Promise.reject(response.status)))
        .then((json) => {
          if (inflight !== request) {
            return;
          }

          const html = json && json[sectionId];
          if (!html) {
            return;
          }

          const doc = new DOMParser().parseFromString(html, 'text/html');
          const nextEmpty = !!doc.querySelector(`.${EMPTY_CLASS}`);
          const currentEmpty = !!document.querySelector(`.${EMPTY_CLASS}`);

          // Empty state toggled (e.g. the last paid item was removed): reload so the
          // whole section, including the summary column, is rendered server-side.
          if (nextEmpty !== currentEmpty) {
            window.location.reload();
            return;
          }

          const nextContainer = doc.querySelector(SELECTOR);
          const currentContainer = getContainer();
          if (nextContainer && currentContainer) {
            currentContainer.replaceWith(nextContainer);
          }

          const nextCount = doc.querySelector(COUNT_SELECTOR);
          if (nextCount) {
            document.querySelectorAll(COUNT_SELECTOR).forEach((element) => {
              element.textContent = nextCount.textContent;
            });
          }
        })
        .catch(() => {});

      inflight = request;
    };

    // The app adds the gift shortly after the cart changes, so refresh twice:
    // once right away and once after the app has had time to act.
    const schedule = () => {
      while (timers.length) {
        clearTimeout(timers.pop());
      }
      timers.push(setTimeout(refresh, 300));
      timers.push(setTimeout(refresh, 2000));
    };

    if (!getContainer()) {
      return;
    }

    ['cart:updated', 'cart:build', 'ajaxProduct:added'].forEach((eventName) => {
      document.addEventListener(eventName, schedule);
    });
    document.body.addEventListener('docapp-free-gift-progress-updated', schedule);

    // On load the app may still be adding a gift for a cart that already qualifies.
    timers.push(setTimeout(refresh, 1500));
    timers.push(setTimeout(refresh, 4000));
  })();
})(window.SHIGETA_THEME_CUSTOMIZE);
